import { render, staticRenderFns } from "./agentPolicyConfig.vue?vue&type=template&id=3b7a34ba&scoped=true&"
import script from "./agentPolicyConfig.vue?vue&type=script&lang=js&"
export * from "./agentPolicyConfig.vue?vue&type=script&lang=js&"
import style0 from "./agentPolicyConfig.vue?vue&type=style&index=0&id=3b7a34ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a34ba",
  null
  
)

export default component.exports